"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBetween = void 0;
const tslib_1 = require("tslib");
const toNumber_1 = tslib_1.__importDefault(require("lodash/toNumber"));
const isBetween = (search, min, max) => {
    const parsedMin = (0, toNumber_1.default)(min);
    const parsedMax = (0, toNumber_1.default)(max);
    const parsedSearch = (0, toNumber_1.default)(search);
    return parsedSearch >= parsedMin && parsedSearch <= parsedMax;
};
exports.isBetween = isBetween;
